import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/groups/${resource.id}/edit`} />,
    <MenuItem primaryText='All Members' key='members' value={`/write-now/members?filters[group_id]=${resource.id}`} />,
    <MenuItem primaryText='Coaches' key='coaches' value={`/write-now/members?filters[group_id]=${resource.id}&filters[coach_role]=coach`} />,
    <MenuItem primaryText='Head Coaches' key='head_coaches' value={`/write-now/members?filters[group_id]=${resource.id}&filters[coach_role]=head_coach`} />
  ]
}

export default buildMenuItems
